<div class="sc_popup_wrap">
  <div class="sc_popup_container">
    <div class="sc_popup_head">
      <img src="https://www.samsungcareplus.com/resources/image/svg/img_sclogo.svg" alt="Samsung Care+ Logo">
      <h1>Activation Page</h1>
      <p>Please provide the following details to activate Samsung Care+</p>
    </div>

    <form [formGroup]="activationForm" class="sc_popup_con" novalidate>
      <p class="text_right"><span class="point">*</span> Required Fields</p>

      <div class="input_wrap">
        <label for="firstName">First Name <span class="point">*</span></label>
        <input type="text" id="firstName" formControlName="firstName" />
        <p class="warning" [class.show]="hasError('firstName')">Invalid data. Please try again.</p>
      </div>

      <div class="input_wrap">
        <label for="lastName">Last Name <span class="point">*</span></label>
        <input type="text" id="lastName" formControlName="lastName" />
        <p class="warning" [class.show]="hasError('lastName')">Invalid data. Please try again.</p>
      </div>

      <div class="input_wrap">
        <label for="email">Email <span class="point">*</span></label>
        <input type="email" id="email" formControlName="email" />
        <p class="warning" [class.show]="hasError('email')">Invalid data. Please try again.</p>
      </div>

      <div class="sc_popup_foot">
        <button (dblclick)="onDblClick($event)"
                [disabled]="isSubmitting || isSubmitted"
                (click)="onSubmit($event)"
                type="submit" class="btn btn-black">{{ isSubmitted ? 'Submit Completed' : (isSubmitting ? 'Submitting...' : 'Submit') }}</button>
      </div>
    </form>
  </div>
</div>
